// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import locale from 'element-ui/lib/locale/lang/da'
import App from './App'
import store from './store'
import CheeseList from './components/CheeseList.vue'
import MemberList from './components/MemberList.vue'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(ElementUI, { locale })

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'cheese',
      component: CheeseList
    },
    {
      path: '/medlemmer',
      name: 'members',
      component: MemberList
    },
  ]
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  store,
  router,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js